import * as React from 'react';
import { compose, withProps } from 'recompose';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
} from 'react-google-maps';
import _config from 'src/services/google-maps/config';
import { MarkerWithLabel } from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import LoadingFrame from 'src/components/LoadingFrame';

const config = _config({});
const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${config.apiKey}` + 
 `&v=3.exp&libraries=geometry,drawing,places`;

const MapWithAMarkerWithLabel = compose(
  withProps({
    googleMapURL,
    loadingElement: <LoadingFrame name="grid" />,
    containerElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(props => (
    <GoogleMap
        defaultZoom={8}
        defaultCenter={{
            lat: -36.9448729,
            lng: 174.63055269999995 // co-ordinate for corr-systems
        }}
    >
        {props.geoSpread.map((_spread, index) => {
            const spreadOverride: any = {};
            if (Array.isArray(_spread.labelAnchor)) {
                spreadOverride.labelAnchor = new google.maps.Point(_spread.labelAnchor[0], _spread.labelAnchor[1]);
            }
            const spread = Object.assign({}, _spread, spreadOverride);
            return (
                <MarkerWithLabel
                    key={index}
                    {...spread}
                >
                    {spread.children}
                </MarkerWithLabel>
            );
        })}
    </GoogleMap>
));

export default MapWithAMarkerWithLabel;


// WEBPACK FOOTER //
// ./src/container/Chart/renders/GeoSpreadChart.tsx